function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  d: "m127.4 182.1 3.8-4.8a401 401 0 0 0 46-84.4c4.4-11.3 7.5-23.1 10-35 1.2-6 .4-12.6-.8-18.7-1.3-6-5.8-8.4-12.1-8-7.2.4-13 4-18.2 8.5-11 9-19.3 20.3-26 32.6-5.4 10-9.8 20.7-14.3 31.2-1 2.5-1.1 5.3-4.2 6.2-3.4 1-5.5-1.2-7.1-3.4-3.3-4.5-6.5-9-9.2-13.7-7.2-12.4-14-25-21.3-37.3a82 82 0 0 0-18.9-23.7A17.9 17.9 0 0 0 33.7 30a22.2 22.2 0 0 0-11.8 16c-1 5.8-1.3 11.9-.5 17.7 1.6 12.7 8.2 23.1 16 32.8C50 111.8 65.2 124.3 80.2 137c16.3 13.8 33.3 26.8 45.8 44.4.1.2.6.3 1.5.7m-17.6-116c4.1-5.8 7.9-11.4 12-16.8A87.7 87.7 0 0 1 152.5 24c9.6-4.7 19.7-5.9 30-3a29 29 0 0 1 20.2 18.5c4 10.3 3.7 21 1.7 31.6a196 196 0 0 1-56.7 108.8c-5 5-11.2 9-16.8 13.4-1.8 1.4-3.3 1.5-5.3.2-21.9-14.7-44-28.8-65.5-44a178.6 178.6 0 0 1-44.4-44.2A77.4 77.4 0 0 1 0 60.3a44.3 44.3 0 0 1 62.2-41 93.4 93.4 0 0 1 44 41.3l2.5 4.4c.1.3.4.5 1.1 1.1"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 206 206"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/casamentos.c7ef608c.svg";
export { SvgComponent as ReactComponent };